/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { DisambiguatedOrganization } from './DisambiguatedOrganization';
import {
    DisambiguatedOrganizationFromJSON,
    DisambiguatedOrganizationFromJSONTyped,
    DisambiguatedOrganizationToJSON,
    DisambiguatedOrganizationToJSONTyped,
} from './DisambiguatedOrganization';
import type { OrganizationAddress } from './OrganizationAddress';
import {
    OrganizationAddressFromJSON,
    OrganizationAddressFromJSONTyped,
    OrganizationAddressToJSON,
    OrganizationAddressToJSONTyped,
} from './OrganizationAddress';

/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization  {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    name: string;
    /**
     * 
     * @type {OrganizationAddress}
     * @memberof Organization
     */
    address: OrganizationAddress;
    /**
     * 
     * @type {DisambiguatedOrganization}
     * @memberof Organization
     */
    disambiguatedOrganization?: DisambiguatedOrganization;
}

/**
 * Check if a given object implements the Organization interface.
 */
export function instanceOfOrganization(value: object): value is Organization {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function OrganizationFromJSON(json: any): Organization {
    return OrganizationFromJSONTyped(json, false);
}

export function OrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organization {
    if (json == null) {
        return json;
    }
    return {
        
                  'name': json['name'],
                  'address': OrganizationAddressFromJSON(json['address']),
                  'disambiguatedOrganization': json['disambiguatedOrganization'] == null ? undefined : DisambiguatedOrganizationFromJSON(json['disambiguatedOrganization']),
    };
}

export function OrganizationToJSON(json: any): Organization {
    return OrganizationToJSONTyped(json, false);
}

export function OrganizationToJSONTyped(value?: Organization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'address': OrganizationAddressToJSON(value['address']),
        'disambiguatedOrganization': DisambiguatedOrganizationToJSON(value['disambiguatedOrganization']),
    };
}


